import { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { Loading } from '../../io/loading';
import { FirstSide, SecondSide, RootSection, Content } from './split-screen.styles';
export interface SplitScreenProps {
    first: ReactNode;
    second: ReactNode;
    firstSideBackgroundColor?: string;
    secondSideBackgroundColor?: string;
    contentHeight?: number;
    firstSideLoading?: boolean;
    secondSideLoading?: boolean;
    size?: number;
    padding?: string;
    firstContentAlign?: string;
}
export function SplitScreen({
    first,
    second,
    contentHeight = 720,
    firstSideBackgroundColor,
    secondSideBackgroundColor,
    firstSideLoading = false,
    secondSideLoading = false,
    size,
    padding,
    firstContentAlign,
}: SplitScreenProps) {
    const theme = useTheme();
    const firstSideWidth = size ?? 360;
    const firstBg = firstSideBackgroundColor ?? theme.firstSideBackgroundColor;
    const secondBg = secondSideBackgroundColor ?? theme.secondSideBackgroundColor;
    return (
        <RootSection
            $firstSideBackgroundColor={firstBg}
            $secondSideBackgroundColor={secondBg}
            $padding={padding}
        >
            <FirstSide $backgroundColor={firstBg} $maxWidth={firstSideWidth}>
                <Content $minHeight={contentHeight} $firstContentAlign={firstContentAlign}>
                    {firstSideLoading ? <Loading /> : first}
                </Content>
            </FirstSide>

            <SecondSide $backgroundColor={secondBg}>
                <Content>{secondSideLoading ? <Loading /> : second}</Content>
            </SecondSide>
        </RootSection>
    );
}
